export const GET_OAUTH = 'getOAuth'
export const GET_OAUTH_TOP = 'getOAuthTop'
export const LINE_REGISTRATION = 'lineRegistration'
export const LINE_PROFILE_REGISTRATION = 'lineProfileRegistration'
export const LINE_NO_PROFILE_REGISTRATION = 'lineNoProfileRegistration'
export const LINE_LIFF_PROFILE_REGISTRATION = 'lineLiffProfileRegistration'
export const LINE_LIFF_NO_PROFILE_REGISTRATION = 'lineLiffNoProfileRegistration'
export const LINE_TOP_REGISTRATION = 'lineTopRegistration'
